module.exports = __webpack_public_path__ + "static/fonts/SourceSansPro-LightItalic.fc5771b.woff";